import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageTitle } from "@/admin/ui";

const Table = ({ cols, rows, testId, empty }) => (
  <div className="overflow-x-auto rounded-md border border-border">
    <table className="w-full text-sm" data-testid={testId}>
      <thead className="bg-secondary/50 text-left text-xs uppercase text-muted-foreground"><tr>{cols.map((c) => <th key={c[0]} className="px-3 py-2">{c[0]}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => <tr key={i} className="border-t border-border align-top">{cols.map((c) => <td key={c[0]} className="px-3 py-2 text-xs">{c[1](r)}</td>)}</tr>)}
        {!rows.length && <tr><td colSpan={cols.length} className="px-3 py-10 text-center text-muted-foreground">{empty}</td></tr>}
      </tbody>
    </table>
  </div>
);

const when = (s) => s.slice(0, 19).replace("T", " ");

export function Messages() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/messages").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageTitle title="Messages" sub="Contact, complaint and feedback submissions." />
      <Table testId="messages-table" empty="No messages." rows={rows} cols={[["Date", (r) => when(r.at)], ["From", (r) => `${r.name} <${r.email}>`], ["Subject", (r) => r.subject], ["Message", (r) => <span className="whitespace-pre-line">{r.message}</span>]]} />
    </div>
  );
}

export function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageTitle title="Audit Log" sub="Critical administrative actions and sign-in events." />
      <Table testId="audit-table" empty="No events." rows={rows} cols={[["Time", (r) => when(r.at)], ["Actor", (r) => r.actor], ["Action", (r) => <span className="font-mono-ui">{r.action}</span>], ["Details", (r) => <span className="block max-w-xl break-all font-mono-ui text-muted-foreground">{JSON.stringify(r.details)}</span>]]} />
    </div>
  );
}
